export default __webpack_public_path__ + "static/media/promo-bottom-bg.43df54c8.svg";